import { atom } from 'jotai';

export const openedMenuAtom = atom<string | null>(null);
